import { defineComponent as _defineComponent } from 'vue';
import { SelectTrigger } from 'reka-ui';
import { ChevronsUpDown } from 'lucide-vue-next';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'SelectTrigger',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, get SelectTrigger() { return SelectTrigger; }, get ChevronsUpDown() { return ChevronsUpDown; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
